import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initOffice } from './lib/office';
void (async () => {
    try {
        await initOffice();
    }
    catch {
        // Office.js failed to init — render anyway so login screen shows
    }
    const root = document.getElementById('root');
    if (!root)
        throw new Error('Missing #root');
    createRoot(root).render(_jsx(App, {}));
})();
